/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';

import { EStyle, EStyleObj } from '~src/types';

interface NavIconProps {
  icon: string;
  customStyle?: EStyle;
}

export const NavIcon: React.FC<NavIconProps> = ({ icon, customStyle }) => {
  return <img css={[style.img, customStyle]} src={icon} alt="" />;
};

const style: EStyleObj = {
  img: {
    height: '80%',
    marginLeft: '-2px',
    marginTop: '2px',
    float: 'left',
    opacity: 0.8,
  },
};
